module.exports = __webpack_public_path__ + "img/bc-step-3.156b27a7.png";